export function hexToBase64(hex: string) {
  // Convert hex to bytes
  const bytes = Buffer.from(hex, 'hex');

  // Encode bytes to Base64
  return bytes.toString('base64');
}
